import apiClient from "./apiClient";
import { getMedicineInventoryList } from "./medicineInventoryService";
import {
  buildLowStockMedicineList,
  countOutOfStockMedicines,
  mapLowStockToDashboardInventoryRows,
  normalizeLowStockMedicineList,
  readLowStockQuantityThreshold,
} from "../utils/medicineLowStock";

const SETTINGS_BASE = "/pharmacy-settings";

/**
 * Fetch medicines at or below the low-stock quantity threshold.
 * Uses backend API when available; otherwise computes from inventory.
 */
export const fetchLowStockMedicines = async (organizationId) => {
  try {
    const response = await apiClient.get(`${SETTINGS_BASE}/low-stock-medicines`);
    const list = normalizeLowStockMedicineList(response.data);
    if (list.length > 0 || Array.isArray(response.data?.medicines)) {
      return list;
    }
  } catch (error) {
    if (error.response?.status && error.response.status !== 404) {
      console.warn("[pharmacyLowStock] API fetch failed, using inventory:", error.message);
    }
  }

  const threshold = readLowStockQuantityThreshold(organizationId);
  const inventory = await getMedicineInventoryList();
  return buildLowStockMedicineList(inventory, threshold);
};

/** @deprecated Prefer fetchLowStockDashboardSummary for dashboard. */
export const fetchOutOfStockMedicineCount = async (organizationId) => {
  const summary = await fetchLowStockDashboardSummary(organizationId);
  return summary.alertCount;
};

/** Top medicines going OOS / low stock for dashboard chart (lowest qty first). */
export const fetchDashboardInventoryStatus = async (
  organizationId,
  limit = 5
) => {
  const summary = await fetchLowStockDashboardSummary(organizationId, limit);
  return summary.chartRows;
};

/** Single fetch for dashboard OOS tile + inventory status list. */
export const fetchLowStockDashboardSummary = async (
  organizationId,
  chartLimit = 5
) => {
  const list = await fetchLowStockMedicines(organizationId);
  const outOfStockCount = countOutOfStockMedicines(list);
  const lowStockCount = list.length;

  return {
    medicines: list,
    lowStockCount,
    outOfStockCount,
    /** Tile value: all medicines needing reorder (low + out of stock). */
    alertCount: lowStockCount,
    chartRows: mapLowStockToDashboardInventoryRows(list, chartLimit),
  };
};
